import React, { useEffect, useState } from "react";
import adviser from "../../assets/members/chief-advisor.png";
import api from "../../utils/axios.config";
import { MessageSquareQuote, User, BookOpen, Loader2 } from "lucide-react";

const PrincipleAdviserMember = () => {
  const [message, setMessage] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleGetMessage = async () => {
    try {
      setLoading(true);
      const { data } = await api.get("adviser-message");
      setMessage(data.adviserMessage);
    } catch (error) {
      console.error("Failed to fetch adviser message:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGetMessage();
  }, []);

  return (
    <div className="max-w-6xl mx-auto px-4 mt-20 py-8 bg-gradient-to-b from-primary/5 to-white">
      {/* Header with decorative elements */}
      <div className="text-center mb-8">
        <h1 className="relative inline-block text-3xl md:text-4xl font-bold text-primary mb-2">
          <span className="absolute -left-8 top-1/2 transform -translate-y-1/2 hidden md:block">
            <MessageSquareQuote className="h-6 w-6 text-primary/70" />
          </span>
          প্রধান উপদেষ্টার বাণী
          <span className="absolute -right-8 top-1/2 transform -translate-y-1/2 hidden md:block">
            <MessageSquareQuote className="h-6 w-6 text-primary/70 transform rotate-180" />
          </span>
        </h1>
        <div className="h-1 w-24 bg-primary mx-auto rounded-full"></div>
      </div>

      {/* Card Container */}
      <div className="flex flex-col md:flex-row gap-8 items-stretch">
        {/* Profile Card */}
        <div className="flex-1 bg-white rounded-lg shadow-lg overflow-hidden flex flex-col">
          <div className="bg-primary py-4 px-6 text-center">
            <h2 className="text-xl font-semibold text-white flex items-center justify-center">
              <User className="mr-2 h-5 w-5" />
              প্রধান উপদেষ্টা
            </h2>
          </div>

          <div className="p-6 text-center flex-grow">
            <div className="mb-4 relative">
              <div className="w-40 h-40 mx-auto rounded-full overflow-hidden border-4 border-primary/10 shadow-md">
                <img
                  src={adviser}
                  alt="Principal Adviser"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            <h3 className="text-xl font-bold text-gray-800 mb-1">
              সমাজবিজ্ঞানী প্রফেসর ড: অনুপম সেন
            </h3>

            <div className="flex items-center justify-center mb-1 text-primary">
              <BookOpen className="h-4 w-4 mr-1" />
              <p className="text-md">
                শিক্ষাক্ষেত্রে বিশেষ অবদানে একুশে পদক ভূষিত
              </p>
            </div>

            <p className="text-gray-600">প্রাক্তন উপাচার্য</p>
            <p className="text-gray-600">প্রিমিয়ার ইউনিভার্সিটি বাংলাদেশ</p>
          </div>
        </div>

        {/* Message Card */}
        <div className="flex-1 bg-white rounded-lg shadow-lg overflow-hidden flex flex-col">
          <div className="bg-primary py-4 px-6">
            <h2 className="text-xl font-semibold text-white flex items-center">
              <MessageSquareQuote className="mr-2 h-5 w-5" />
              প্রধান উপদেষ্টার বাণী
            </h2>
          </div>

          <div className="p-6 flex-grow">
            {loading ? (
              <div className="flex items-center justify-center h-full">
                <Loader2 className="h-8 w-8 text-primary animate-spin" />
              </div>
            ) : (
              <div className="prose max-w-none text-gray-700 leading-relaxed">
                {message && message[message?.length - 1]?.message}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrincipleAdviserMember;
